import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const getShareTemplatesService = async () => {
  try {
    return await http.get('/v1/ratings/share-templates');
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('getShareTemplatesService ', error);
  }
};

export const createShareTemplateService = async (data: any) => {
  try {
    return await http.post('/v1/ratings/share-templates', data, () => {});
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('createShareTemplateService ', error);
  }
};

export const updateShareTemplateService = async (id: string, data: any) => {
  try {
    return await http.put(`/v1/ratings/share-templates/${id}`, data);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('updateShareTemplateService ', error);
  }
};

export const deleteShareTemplateService = async (id: string) => {
  try {
    return await http.delete(`/v1/ratings/share-templates/${id}`);
  } catch (error: any) {
    if (error && !error.ok) {
      return error;
    }
    console.log('deleteShareTemplateService ', error);
  }
};
